import {FaHome} from "react-icons/fa";
import Select from "react-select";
import {RadioGroup} from "../RadioGroup";
import BottomButtonWrapper from "../BottomButtonWrapper";
import Button from "../Button";
import React, {useEffect, useState} from "react";
import Api from "../../tools/service";
import Swal from "sweetalert2";
import {useFormik} from "formik";
import * as Yup from "yup";
const documentValidation = Yup.object().shape({
    province: Yup.string().when('radioOption', {
        is: (value) => {
            return value === 'Old'
        },
        then: (schema) => schema.required('فیلد استان الزامیست.'),
        otherwise: (schema) => schema,
    }),
    unitId:Yup.string().when('radioOption', {
        is: (value) => {
            return value === 'Old'
        },
        then: (schema) => schema.required('واحد ثبتی اصلی الزامیست.'),
        otherwise: (schema) => schema,
    }),
    basic:Yup.string().when('radioOption', {
        is: (value) => {
            return value === 'Old'
        },
        then: (schema) => schema.required('فیلد اصلی الزامیست.'),
        otherwise: (schema) => schema,
    }),
    secondary:Yup.string().when('radioOption', {
        is: (value) => {
            return value === 'Old'
        },
        then: (schema) => schema.required('فیلد فرعی الزامیست.'),
        otherwise: (schema) => schema,
    }),
    pageNumber: Yup.string().when('radioOption', {
        is: (value) => {
            return value === 'Old'
        },
        then: (schema) => schema.required('فیلد شماره صفحه الزامیست.'),
        otherwise: (schema) => schema,
    }),
    officeNumber: Yup.string().when('radioOption', {
        is: (value) => {

            return value === 'Old'
        },
        then: (schema) => schema.required('فیلد شماره صفحه الزامیست.'),
        otherwise: (schema) => schema,
    }),
    uniqueId: Yup.string().when('radioOption', {
        is: (value) => {
            return value === 'NewTwoFactor'
        },
        then: (schema) => schema.required('فیلد شناسه یکتا سند / شماره دفتر املاک الکترونیکی الزامیست.'),
        otherwise: (schema) => schema,
    }),

});
const DocumentInformationForm = (props) => {
    const {onConfirm,processInfo,accessToken,handlePrev}=props;
    const [province, setProvince] = useState([]);
    const [unitList, setUnitList] = useState([]);
    const [selectedProvince, setSelectedProvince] = useState(null)
    const [selectedUnitId, setSelectedUnitId] = useState(null);
    const [documentType, setDocumentType] = useState(processInfo?.confirmed_data?.DocumentType ? processInfo?.confirmed_data?.DocumentType : 'NewTwoFactor');
    const [provinceLoading, setProvinceLoading] = useState(true);
    const [unitLoading, setUnitLoading] = useState(false);
    const handleChangeDocumentType = (type) => {
        formik.setFieldValue('radioOption', type);
        setDocumentType(type);

    }
    const handleSubmit = (values) => {
        const data = {documentType, ...values};
        onConfirm(data)
    }
    const formik = useFormik({
        initialValues: {

            radioOption: processInfo?.confirmed_data?.DocumentType ? processInfo?.confirmed_data?.DocumentType : 'NewTwoFactor',

            ...(documentType === "NewTwoFactor" && {uniqueId: processInfo?.confirmed_data?.UniqueId ? processInfo?.confirmed_data?.UniqueId : ''}),
            ...(documentType === "Old" && {
                province: '',
                unitId: '',
                officeNumber: processInfo?.confirmed_data?.OfficeNumber ? processInfo?.confirmed_data?.OfficeNumber : '',
                pageNumber: processInfo?.confirmed_data?.PageNumber ? processInfo?.confirmed_data?.PageNumber : '',
                basic: processInfo?.confirmed_data?.Basic ? processInfo?.confirmed_data?.Basic : '',
                secondary: processInfo?.confirmed_data?.Secondary ? processInfo?.confirmed_data?.Secondary : '',
            }),


        },
        validationSchema: documentValidation,
        onSubmit: handleSubmit
    });

    const onProvinceChange = (data) => {
        setUnitLoading(true)
        setSelectedProvince(data)
        formik.setFieldValue(
            'province',
            data.value,
        )
        setSelectedUnitId('')
        handleGenerateUuid('EstateUnits').then((uuid) => {
            Api.get('/api/v1/Fronts/EstateUnits', {
                params: {
                    uuid,
                    ProvinceId: data.value,
                }
            }).then(response => {

                if (!response.hasError) {
                    const newArray = response.data.map(({Id: value, Name: label}) => ({
                        value: value.value,
                        label: label.value
                    }));

                    setUnitList(newArray)
                } else {

                }
            }).catch(e => {

            }).finally(() => {
                setUnitLoading(false)
            })
        })
    }
    const onUnitChange = (e) => {
        setSelectedUnitId(e)
        formik.setFieldValue(
            'unitId',
            e.value,
        )
    }
    useEffect(async () => {
        handleGetProvince()
    }, [])

    const handleGenerateUuid = async (type) => {
        try {
            const response = await Api.post('/api/v1/Providers/GenUuidV2', {
                request_type: type,
                callback_url: "https://venesh.ir"
            }, {
                headers: {
                    "Authorization": `Bearer ${accessToken}`
                }
            });
            if (response && !response.hasError) {

                return response.data.uuid;
            } else {

                Swal.fire({
                    text: response.message,
                    title: "ناموفق",
                    icon: 'error',
                    backdrop: true,
                    focusConfirm: false,
                    showCancelButton: false,
                    confirmButtonColor: '#d51e3e',
                    confirmButtonText: 'تلاش مجدد',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    allowEscapeKey: false,


                }).then((result) => {


                });

                throw new Error(response.message)
            }
        } catch (error) {
            console.log(error)

        } finally {

        }
    };
    const handleGetProvince = () => {
        setProvinceLoading(true)
        handleGenerateUuid('EstateProvinces').then(uuid => {
            Api.get('/api/v1/Fronts/EstateProvinces', {
                params: {
                    uuid,
                }
            }).then(response => {

                if (!response.hasError) {
                    const newArray = response.data.map(({Id: value, Name: label}) => ({
                        value: value.value,
                        label: label.value
                    }));
                    setProvince(newArray)
                    setProvinceLoading(false)
                }
            }).catch(e => {
                setProvinceLoading(false)
            }).finally(() => {


            })
        }).catch(e => {
            console.log(e)
        })
    }

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            border: 'none',
            padding: '3px',
            backgroundColor: 'rgb(243, 244, 246)',
            borderRadius: '0.75rem'
        }),
        input: (provided, state) => ({
            ...provided,
            borderRadius: '17px',
            // Add your custom styles for the input here
            color: 'red', // Example: Change text color to red
        }),
    };
    return <form onSubmit={formik.handleSubmit} className="w-full rounded-xl bg-white max-w-md p-5 justify-self-center flex flex-col gap-3  ">
        <div className="mb-3 border-b flex flex-col justify-center items-center  pb-3">
            <div className=" p-3 border-2 border-green-300 rounded-full bg-green-500 bg-opacity-20">
                <FaHome className="text-green-500 text-3xl "/>
            </div>
            <h1 className="mt-3 text-sm font-bold">اطلاعات ملک را وارد کنید.</h1>
        </div>
        <div className="w-full   ">
            <div className=" w-full">
                <p className="text-sm mt-2 mb-1">نوع سند را انتخاب کنید</p>
                <RadioGroup selectedIndex={documentType === 'Old' ? 1 : 0} handleChange={handleChangeDocumentType}
                            items={[
                                {
                                    value: "NewTwoFactor",
                                    text: "جدید"
                                },
                                {
                                    value: "Old",
                                    text: "قدیمی"
                                }
                            ]}/>
            </div>
            {documentType==='Old' && <>
                <div className="w-full grid mt-2 grid-cols-1 lg:grid-cols-1 gap-2 ">
                    <div>
                        <label className="text-sm" htmlFor="province">استان</label>
                        <Select
                            loadingMessage={() => <div>لطفا منتظر بمانید</div>}
                            defaultValue={selectedProvince}
                            onChange={onProvinceChange}
                            options={province}
                            value={selectedProvince}
                            isLoading={provinceLoading}
                            placeholder={'استان '}
                            noOptionsMessage={() => {
                                return <>موردی یافت نشد</>
                            }}
                            styles={customStyles}
                            className="text-sm"
                            isRtl={true}
                            name="province"
                            isSearchable={true}
                        />
                        {formik.errors.province && formik.touched.province ? (
                            <p className="text-red-400 text-sm font-light  ">{formik.errors.province}</p>
                        ) : null}
                    </div>
                    <div>
                        <label className="text-sm" htmlFor="UnitId">واحد ثبتی</label>
                        <Select
                            defaultValue={selectedUnitId}
                            onChange={onUnitChange}
                            isLoading={unitLoading}
                            options={unitList}
                            loadingMessage={() => <div>لطفا منتظر بمانید</div>}
                            value={selectedUnitId}
                            placeholder={'واحد ثبتی'}
                            noOptionsMessage={() => {
                                return <>موردی یافت نشد</>
                            }}
                            name="unitId"
                            styles={customStyles}
                            className="text-sm"
                            isRtl={true}
                            isSearchable={true}
                        />
                        {formik.errors.unitId && formik.touched.unitId ? (
                            <p className="text-red-400 text-sm font-light  ">{formik.errors.unitId}</p>
                        ) : null}
                    </div>
                </div>
                <div className="w-full grid gap-2 mt-2 grid-cols-2 ">
                    <div className="w-full flex flex-col">
                        <label className="text-sm " htmlFor="basic">اصلی </label>
                        <input dir="ltr" onChange={formik.handleChange} value={formik.values.basic} type="tel"
                               className="w-full bg-gray-100  text-right text-sm rounded-lg p-3" placeholder="اصلی"
                               name="basic"/>
                        {formik.errors.basic && formik.touched.basic ? (
                            <p className="text-red-400 text-sm font-light  ">{formik.errors.basic}</p>
                        ) : null}
                    </div>
                    <div className="w-full flex flex-col">
                        <label className="text-sm " htmlFor="secondary">فرعی</label>
                        <input dir="ltr" onChange={formik.handleChange} value={formik.values.secondary} type="tel"
                               className="w-full bg-gray-100 text-sm text-right rounded-lg p-3" placeholder="فرعی"
                               name="secondary"/>
                        {formik.errors.secondary && formik.touched.secondary ? (
                            <p className="text-red-400 text-sm font-light  ">{formik.errors.secondary}</p>
                        ) : null}
                    </div>
                </div>
            </>}
        </div>
        <div className="grid grid-cols-1 mt-2 w-full gap-3 ">
            {documentType === "NewTwoFactor" &&
                <div className="grid grid-cols-1 mt-2  gap-2">

                    <div className="flex flex-col">
                        <label className="text-sm" htmlFor="uniqueId">شناسه یکتا سند / شماره دفتر املاک
                            الکترونیکی</label>
                        <input dir="ltr" onChange={formik.handleChange} value={formik.values.uniqueId} type="tel"
                               className="w-full bg-gray-100 text-sm  text-right rounded-lg p-3"
                               placeholder="شناسه یکتا سند / شماره دفتر املاک الکترونیکی"
                               name="uniqueId"/>
                        {formik.errors.uniqueId && formik.touched.uniqueId ? (
                            <p className="text-red-400 text-sm font-light  ">{formik.errors.uniqueId}</p>
                        ) : null}
                    </div>
                </div>}
            {documentType === "Old" &&
                <div className="grid grid-cols-2 mt-2  gap-2">

                    <div className="flex flex-col">
                        <label className="text-sm" htmlFor="officeNumber">شماره دفتر </label>
                        <input dir="ltr" onChange={formik.handleChange} value={formik.values.officeNumber}
                               type="tel" className="w-full text-sm bg-gray-100  text-right rounded-lg p-3"
                               placeholder="شماره دفتر"
                               name="officeNumber"/>
                        {formik.errors.officeNumber && formik.touched.officeNumber ? (
                            <p className="text-red-400 text-sm font-light  ">{formik.errors.officeNumber}</p>
                        ) : null}
                    </div>
                    <div className="flex flex-col">
                        <label className="text-sm" htmlFor="pageNumber">شماره صفحه</label>
                        <input dir="ltr" onChange={formik.handleChange} value={formik.values.pageNumber} type="tel"
                               className="w-full bg-gray-100  text-sm text-right rounded-lg p-3"
                               placeholder="شماره صفحه"
                               name="pageNumber"/>
                        {formik.errors.pageNumber && formik.touched.pageNumber ? (
                            <p className="text-red-400 text-sm font-light  ">{formik.errors.pageNumber}</p>
                        ) : null}
                    </div>
                </div>}
        </div>
        <div className="grid grid-cols-2 gap-1">
            <Button onClick={handlePrev} type="button" rounded="rounded-lg"
                    className="w-full  text-sm flex justify-center items-center"
                    theme="link"><span>مرحله قبل</span></Button>
            <Button disabled={documentType==="Old" ? provinceLoading || unitLoading :false} type="submit" rounded="rounded-lg"
                    className="w-full text-sm  flex justify-center items-center"
                    theme="green"><span>مرحله بعد</span></Button>
        </div>
    </form>
}
export default DocumentInformationForm;